"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var Sentry = _interopRequireWildcard(require("@sentry/browser"));
var _config = _interopRequireDefault(require("../../config.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = {
  init: function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    Sentry.init(_objectSpread({
      dsn: _config["default"].sentryDns,
      environment: process.env.NODE_ENV
    }, options));
  },
  trackError: function trackError(description) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var fatal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var createSentryAlert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var otherProperties = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    if (!createSentryAlert) return;
    if (error instanceof Error) {
      var sentryError = new Error(error.message);
      if (error.stack) sentryError.stack = error.stack;
      if (error.code) sentryError.code = error.code;
      if (error.errno) sentryError.errno = error.errno;
      if (error.syscall) sentryError.syscall = error.syscall;
      sentryError.message = "".concat(description, " ").concat(error.message);
      Sentry.captureException(sentryError);
    } else {
      Sentry.captureMessage(description);
    }
  },
  trackEvent: function trackEvent() {},
  setUserId: function setUserId(userId) {
    Sentry.configureScope(function (scope) {
      scope.setUser({
        id: userId
      });
    });
  },
  setCustomDimension: function setCustomDimension(dimension, value) {
    Sentry.configureScope(function (scope) {
      scope.setTag(dimension, value);
    });
  }
};